import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { defaultStyles } from "./defaultStyles";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "container",
  props: {
    children: {
      prop: "children",
      type: "children",
      value: [],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        container: {
          type: "select",
          value: defaultStyles.container,
        },
        backgroundColor: {
          type: "color",
          value: defaultStyles.backgroundColor,
        },
        borderWidth: {
          type: "number",
          value: defaultStyles.borderWidth,
        },
        borderColor: {
          type: "color",
          value: defaultStyles.borderColor,
        },
        borderRadius: {
          type: "border-radius",
          value: defaultStyles.borderRadius,
        },
        borderStyle: {
          type: "select",
          value: defaultStyles.borderStyle,
        },
        margin: {
          type: "margin",
          value: defaultStyles.margin,
        },
        padding: {
          type: "padding",
          value: defaultStyles.padding,
        },
      },
    },
  },
};
